export const environment = {
  production: true,
  apiUrl: 'https://api.paces.azigrene-energiza.es/'
};
